import { kebabCase } from 'lodash';

import { ThemableCSSPropertiesType } from './CSSVariables.types';

export const toCssVariables = <T extends ThemableCSSPropertiesType>(obj: T) =>
  Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [`--${kebabCase(key)}`, value])
  );
